module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_04_6DB79_1SB_GKK.0492059d.png";